// @mui
import { enUS, frFR, koKR, trTR } from '@mui/material/locale';
import { PATH_DASHBOARD } from './routes/paths';

// LAYOUT
// ----------------------------------------------------------------------
export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 220,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// ----------------------------------------------------------------------
export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeStretch: false,
};

// MULTI LANGUAGES
// ----------------------------------------------------------------------
export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/images/flags/en.png',
  },
  {
    label: 'Turkish',
    value: 'tr',
    systemValue: trTR,
    icon: '/images/flags/tr.png',
  },
  {
    label: 'Korean',
    value: 'kr',
    systemValue: koKR,
    icon: '/images/flags/kr.png',
  },
  {
    label: 'French',
    value: 'fr',
    systemValue: frFR,
    icon: '/images/flags/fr.png',
  },
];

export const defaultLang = allLangs.find((_lang) => _lang.value === process.env.REACT_APP_DEFAULT_LANG);

// ----------------------------------------------------------------------

export const tourSteps = [
  {
    selector: '[data-tour="total-visitor"]',
    page: PATH_DASHBOARD.analytics,
    content: {
      title: 'Total visitors',
      description: 'This is the number of visitors the ATB sent in the selected month from calendar.',
    },
  },
  {
    selector: '[data-tour="analytics-report"]',
    page: PATH_DASHBOARD.analytics,
    content: {
      title: 'This is detailed stats',
      description:
        'This is more details about the number of visitors ATB sent in each day comparing to the previous month.',
    },
  },
  {
    selector: '[data-tour="latest-camps"]',
    page: PATH_DASHBOARD.campaigns.list,
    content: {
      title: 'Latest Campaigns',
      description: 'You can find the latest created campaigns from here and you can add new!',
    },
  },
  {
    selector: '[data-tour="new-campaign"]',
    page: PATH_DASHBOARD.campaigns.new,
    content: {
      title: 'Create a new campaign',
      description: 'You can create a new campaign from here.',
    },
  },
  {
    selector: '[data-tour="threads"]',
    page: PATH_DASHBOARD.threads,
    content: {
      title: 'Thread settings',
      description:
        'You can choose the number of threads you want the bot work and you can also see the list of threads from here.',
    },
  },
  {
    selector: '[data-tour="settings"]',
    page: PATH_DASHBOARD.settings,
    content: {
      title: 'Settings',
      description: 'You can see bunch of advanced settings and you can clear caches and all settings from here.',
    },
  },
  {
    selector: '[data-tour="license-settings"]',
    page: PATH_DASHBOARD.settings,
    content: {
      title: 'License',
      description:
        'You can see information about your device and license key. You can also deactivate the bot from here.',
    },
  },
  {
    selector: '[data-tour="notification"]',
    page: PATH_DASHBOARD.notifications,
    content: {
      title: 'Notification',
      description: "We'll send updates and news through this! Make sure you check this to stay updated!",
    },
  },
];

// ----------------------------------------------------------------------

export const PLATFORMS = [
  { value: 'DESKTOPUSERAGENT', label: 'Desktop' },
  { value: 'MOBILEUSERAGENT', label: 'Mobile' },
  { value: 'TABLETUSERAGENT', label: 'Tablet' },
];

// export const THREAD_MODES = [
//   { value: 'CUSTOM', label: 'Custom' },
//   { value: 'ASSIGNALLCAMPAIGNSTOEACHTHREAD', label: 'Assign all compaigns to each thread' },
//   { value: 'ASSIGNDIFFERENTCAMPAIGNSTOEACHTHREAD', label: 'Assign different compaigns to each thread' },
//   { value: 'DEFAULTSETTING', label: 'Default' },
// ];

export const THREAD_MODES = [
  { value: 'CUSTOM', label: 'Custom' },
  { value: 'DEFAULTSETTING', label: 'Default' },
];

export const PROXY_FORMATS = [
  'Protocol://IP:Port@Username:Password',
  'Protocol://Username:Password@IP:Port',
  'Protocol://IP:Port',
  'Protocol://IP:Port:Username:Password',
];

export const PROXY_PROTOCOLS = ['AUTO', 'HTTPS', 'HTTP', 'SOCKS4', 'SOCKS5'];

export const SCHEDULE_DATE_TYPES = [
  { value: 'SPECIFICDATE', label: 'Specific Date' },
  { value: 'DAYOFWEEK', label: 'Day Of week' },
  { value: 'EVERYDAY', label: 'Every day' },
];

export const SCHEDULE_DAY_OF_WEEKS = [
  { value: 'SUNDAY', label: 'Sunday' },
  { value: 'MONDAY', label: 'Monday' },
  { value: 'TUESDAY', label: 'Tuesday' },
  { value: 'WEDNESDAY', label: 'Wednesday' },
  { value: 'THURSDAY', label: 'Thursday' },
  { value: 'FRIDAY', label: 'Friday' },
  { value: 'SATURDAY', label: 'Saturday' },
];

export const SCHEDULE_SETTINGS = [
  { value: 'DEFAULT', label: 'Default Settings' },
  { value: 'CUSTOM', label: 'Custom Settings' },
];

export const TRAFFIC_MODES = [
  { value: 'SEARCHENGINETRAFFIC', label: 'Search Engine Traffic', icon: 'global-search', show: true },
  { value: 'DIRECTTRAFFIC', label: 'Direct Traffic', icon: 'arrow-swap-horizontal', show: true },
  { value: 'GOOGLEMAPTRAFFIC', label: 'Google Map Traffic', icon: 'map', show: false },
  // { value: 'DEXTRAFFIC', label: 'DEX Traffic', icon: '' },
];

export const TRAFFIC_SENDING_MODES = [
  { value: 'REGULAR', label: 'Regular & Fast' },
  { value: 'ADVANCED', label: 'Advanced' },
  { value: 'CUSTOM', label: 'Custom' },
];

export const RESOURCE_TYPES = [
  { value: 'IMAGE', label: 'Image' },
  { value: 'OBJECT', label: 'Video and Audio' },
  { value: 'STYLESHEET', label: 'CSS (Stylesheet)' },
  { value: 'FONT', label: 'Font' },
  { value: 'SCRIPT', label: 'Script (js codes)' },
];

export const MATCH_CONDITIONS = [
  { label: 'Equals', value: 'EQUALS' },
  { label: 'Contains', value: 'CONTAINS' },
  { label: 'Doesn\'t Equal', value: 'NOTEQUALS' },
  { label: 'Doesn\'t Contain', value: 'NOTCONTAINS' },

];

export const TASK_TYPES = [
  { label: 'Click', value: 'CLICK' },
  { label: 'Type', value: 'TYPE' },
  { label: 'Inject JS', value: 'INJECTJS' },
  { label: 'Inject Cookie', value: 'INJECTCOOKIE' },
];

export const ELEMENT_PRIORITIES = [
  { label: 'In Order', value: 'INORDER' },
  { label: 'Randomised', value: 'RANDOMISED' },
];

export const ELEMENT_TAGS = ['a', 'div', 'input', 'span', 'button', 'iframe', 'li'];

export const ELEMENT_ATTRIBUTES = ['href', 'text', 'id', 'class', 'src'];

export const ELEMENT_CONDITIONS = [
  { label: 'Equal', value: 'EQUALS' },
  { label: 'Contain', value: 'CONTAINS' },
];

export const IP_CHANGING_MODE = [
  { label: 'PPOE', value: 'PPPOEMODE' },
  { label: 'Fritzbox', value: 'FRITZBOX' },
  { label: '3G/4G/5G', value: 'MOBILEMODE' },
  { label: 'VPN', value: 'OPENVPN' },
  { label: 'Root Mode', value: 'ROOTMODE' },
  { label: 'Proxy', value: 'PROXYMODE' },
  { label: 'None', value: 'NONE' },
];

export const TYPE_OF_ACTIONS = [
  { label: 'Create new profiles', value: 'CREATENEWPROFILES' },
  { label: 'Use previous profiles', value: 'USERPREVIOUSPROFILES' },
];

export const TYPE_OF_ACTION_FOR_NEW_PROFILES = [
  { label: 'Save', value: 'SAVE' },
  { label: 'Remove', value: 'REMOVE' },
];

export const BROWSER_TYPES = [
  { label: 'Internal', value: 'INTERNAL' },
  { label: 'Adspower', value: 'ADSPOWER' },
  { label: 'Kameleo', value: 'KAMELEO' },
  { label: 'MultiLogin', value: 'MULTILOGIN' },
  { label: 'Undetectable', value: 'UNDETECTABLE' },
  { label: 'MLX', value: 'MLX' },
  { label: 'Dolphin', value: 'DOLPHIN' },
];

export const INDEX_TYPES = [
  { value: 'SPECIFIC', label: 'Specific Index' },
  { value: 'RANDOM', label: 'Random Index' },
];

export const GOOGLE_MAPS_LISTING_ACTION_TYPES = [
  // { value: 'NONE', label: 'None' },
  { value: 'CLICKONWEBSITE', label: 'Click on website', showDelayInputs: false },
  { value: 'CHECKREVIEWS', label: 'Click reviews', showDelayInputs: true },
  { value: 'CHECKINFORMATION', label: 'Check information', showDelayInputs: true },
  { value: 'DIRECTIONROUTE', label: 'Direction route', showDelayInputs: true },
  { value: 'BOOKMARK', label: 'Bookmark', showDelayInputs: true },
];

export const SEARCH_ENGINES = [
  {
    label: 'Google',
    value: 'GOOGLE',
    logo: '/images/google.png',
    subServices: [
      { value: 'INTEGRATED', label: 'Web Results', icon: 'connected' },
      { value: 'MAP', label: 'Map', icon: 'map-point' },
    ],
    domains: [
      'google.com',
      'google.ad',
      'google.ae',
      'google.com.af',
      'google.com.ag',
      'google.com.ai',
      'google.al',
      'google.am',
      'google.co.ao',
      'google.com.ar',
      'google.as',
      'google.at',
      'google.com.au',
      'google.az',
      'google.ba',
      'google.com.bd',
      'google.be',
      'google.bf',
      'google.bg',
      'google.com.bh',
      'google.bi',
      'google.bj',
      'google.com.bn',
      'google.com.bo',
      'google.com.br',
      'google.bs',
      'google.bt',
      'google.co.bw',
      'google.by',
      'google.com.bz',
      'google.ca',
      'google.cd',
      'google.cf',
      'google.cg',
      'google.ch',
      'google.ci',
      'google.co.ck',
      'google.cl',
      'google.cm',
      'google.cn',
      'google.com.co',
      'google.co.cr',
      'google.com.cu',
      'google.cv',
      'google.com.cy',
      'google.cz',
      'google.de',
      'google.dj',
      'google.dk',
      'google.dm',
      'google.com.do',
      'google.dz',
      'google.com.ec',
      'google.ee',
      'google.com.eg',
      'google.es',
      'google.com.et',
      'google.fi',
      'google.com.fj',
      'google.fm',
      'google.fr',
      'google.ga',
      'google.ge',
      'google.gg',
      'google.com.gh',
      'google.com.gi',
      'google.gl',
      'google.gm',
      'google.gr',
      'google.com.gt',
      'google.gy',
      'google.com.hk',
      'google.hn',
      'google.hr',
      'google.ht',
      'google.hu',
      'google.co.id',
      'google.ie',
      'google.co.il',
      'google.im',
      'google.co.in',
      'google.iq',
      'google.is',
      'google.it',
      'google.je',
      'google.com.jm',
      'google.jo',
      'google.co.jp',
      'google.co.ke',
      'google.com.kh',
      'google.ki',
      'google.kg',
      'google.co.kr',
      'google.com.kw',
      'google.kz',
      'google.la',
      'google.com.lb',
      'google.li',
      'google.lk',
      'google.co.ls',
      'google.lt',
      'google.lu',
      'google.lv',
      'google.com.ly',
      'google.co.ma',
      'google.md',
      'google.me',
      'google.mg',
      'google.mk',
      'google.ml',
      'google.com.mm',
      'google.mn',
      'google.ms',
      'google.com.mt',
      'google.mu',
      'google.mv',
      'google.mw',
      'google.com.mx',
      'google.com.my',
      'google.co.mz',
      'google.com.na',
      'google.com.ng',
      'google.com.ni',
      'google.ne',
      'google.nl',
      'google.no',
      'google.com.np',
      'google.nr',
      'google.nu',
      'google.co.nz',
      'google.com.om',
      'google.com.pa',
      'google.com.pe',
      'google.com.pg',
      'google.com.ph',
      'google.com.pk',
      'google.pl',
      'google.pn',
      'google.com.pr',
      'google.ps',
      'google.pt',
      'google.com.py',
      'google.com.qa',
      'google.ro',
      'google.ru',
      'google.rw',
      'google.com.sa',
      'google.com.sb',
      'google.sc',
      'google.se',
      'google.com.sg',
      'google.sh',
      'google.si',
      'google.sk',
      'google.com.sl',
      'google.sn',
      'google.so',
      'google.sm',
      'google.sr',
      'google.st',
      'google.com.sv',
      'google.td',
      'google.tg',
      'google.co.th',
      'google.com.tj',
      'google.tl',
      'google.tm',
      'google.tn',
      'google.to',
      'google.com.tr',
      'google.tt',
      'google.com.tw',
      'google.co.tz',
      'google.com.ua',
      'google.co.ug',
      'google.co.uk',
      'google.com.uy',
      'google.co.uz',
      'google.com.vc',
      'google.co.ve',
      'google.vg',
      'google.co.vi',
      'google.com.vn',
      'google.vu',
      'google.ws',
      'google.rs',
      'google.co.za',
      'google.co.zm',
      'google.co.zw',
      'google.cat ',
    ],
    activeManageAccount: true,
    activeMode: true,
    activeSpeed: true,
    settingType: 'GoogleTraffic',
  },
  {
    label: 'Bing',
    value: 'BING',
    logo: '/images/bing.png',
    subServices: [],
    domains: ['bing.com'],
    activeManageAccount: true,
    activeMode: false,
    activeSpeed: true,
    settingType: 'BingTraffic',
  },
  {
    label: 'DuckDuckGo',
    value: 'DUCKDUCKGO',
    logo: '/images/duck_duck_go.png',
    subServices: [],
    domains: ['duckduckgo.com'],
    activeManageAccount: false,
    activeMode: false,
    activeSpeed: false,
    settingType: 'TrafficSettings',
  },
  {
    label: 'Yahoo',
    value: 'YAHOO',
    logo: '/images/yahoo.png',
    subServices: [],
    domains: ['yahoo.com'],
    activeManageAccount: false,
    activeMode: false,
    activeSpeed: false,
    settingType: 'YahooTraffic',
  },
  {
    label: 'Yandex',
    value: 'YANDEX',
    logo: '/images/yandex.png',
    subServices: [],
    domains: [
      'yandex.az',
      'yandex.by',
      'yandex.co.il',
      'yandex.com',
      'yandex.com.am',
      'yandex.com.ge',
      'yandex.com.tr',
      'yandex.ee',
      'yandex.fr',
      'yandex.kg',
      'yandex.kz',
      'yandex.lt',
      'yandex.lv',
      'yandex.md',
      'yandex.net',
      'yandex.ru',
      'yandex.tj',
      'yandex.tm',
      'yandex.ua',
      'yandex.uz',
    ],
    activeManageAccount: false,
    activeMode: false,
    activeSpeed: true,
    settingType: 'YandexTraffic',
  },
  {
    label: 'Naver',
    value: 'NAVER',
    logo: '/images/nbank.png',
    subServices: [
      { value: 'INTEGRATED', label: 'Integrated', icon: 'connected' },
      { value: 'VIEW', label: 'View', icon: 'eye-bold' },
      { value: 'SHOPPING', label: 'Shopping', icon: 'shopping' },
      { value: 'MAP', label: 'Map', icon: 'map-point' },
    ],
    domains: ['naver.com'],
    activeManageAccount: true,
    activeMode: false,
    activeSpeed: true,
    settingType: 'NaverTraffic',
  },
  {
    label: 'Baidu',
    value: 'BAIDU',
    logo: '/images/bd.png',
    subServices: [],
    domains: ['baidu.com'],
    activeManageAccount: false,
    activeMode: false,
    activeSpeed: false,
    settingType: 'BaiduTraffic',
  },
  {
    label: 'Amazon',
    value: 'AMAZON',
    logo: '/images/amazon.png',
    subServices: [],
    domains: ['amazon.com'],
    activeManageAccount: false,
    activeMode: false,
    activeSpeed: true,
    settingType: 'TrafficSettings',
  },
  {
    label: 'AYB',
    value: 'AYB',
    logo: '/images/ayb.png',
    subServices: [],
    domains: ['AYB.com'],
    activeManageAccount: false,
    activeMode: false,
    activeSpeed: true,
    settingType: 'TrafficSettings',
  },
];

export const BING_PHASES = [
  { label: 'Phase 1', value: 'PHASE1' },
  { label: 'Phase 2', value: 'PHASE2' },
  { label: 'Phase 3', value: 'PHASE3' },
];

export const DIRECT_REFERRED_WEBSITES = [
  'https://www.google.com',
  'https://www.youtube.com',
  'https://www.facebook.com',
  'https://www.baidu.com',
  'https://www.yahoo.com',
  'https://www.amazon.com',
  'https://www.wikipedia.org',
  'https://www.qq.com',
  'https://www.twitter.com',
  'https://www.google.co.in',
  'https://www.live.com',
  'https://www.taobao.com',
  'https://www.google.co.jp',
  'https://www.sina.com.cn',
  'https://www.bing.com',
  'https://www.instagram.com',
  'https://www.linkedin.com',
  'https://www.weibo.com',
  'https://www.yahoo.co.jp',
  'https://www.viralthread.com',
  'https://www.etsy.com',
  'https://www.amazon.co.uk',
  'https://www.google.ch',
  'https://www.hurriyet.com.tr',
  'https://www.tuberel.com',
  'https://www.gsmarena.com',
  'https://www.paytm.com',
  'https://www.booking.com',
  'https://www.google.sk',
  'https://www.steampowered.com',
  'https://www.babytree.com',
  'https://www.zhihu.com',
  'https://www.chase.com',
  'https://www.businessinsider.com',
  'https://www.wix.com',
  'https://www.pandora.com',
  'https://www.espn.com',
  'https://www.google.az',
  'https://www.slideshare.net',
  'https://www.google.dz',
  'https://www.samsung.com',
  'https://www.acfun.tv',
  'https://www.nametests.com',
  'https://www.google.co.uk',
  'https://www.1905.com',
  'https://www.4dsply.com',
  'https://www.google.co.ve',
  'https://www.buzzhand.com',
  'https://www.google.cn',
  'https://www.googleusercontent.com',
  'https://www.craigslist.org',
  'https://www.uol.com.br',
  'https://www.ebay.com',
  'https://www.terraclicks.com',
  'https://www.blogger.com',
  'https://www.netflix.com',
  'https://www.spiegel.de',
  'https://www.youm7.com',
  'https://www.wikimedia.org',
  'https://www.ebay.it',
  'https://www.mlb.com',
  'https://www.giphy.com',
  'https://www.incometaxindiaefiling.gov.in',
  'https://www.slack.com',
  'https://www.dropbox.com',
  'https://www.blog.jp',
  'https://www.buzzfeed.com',
  'https://www.espn.go.com',
  'https://www.yandex.ru',
  'https://www.clickadu.com',
  'https://www.globo.com',
  'https://www.feedly.com',
  'https://www.fbcdn.net',
  'https://www.engadget.com',
  'https://www.microsoftonline.com',
  'https://www.google.com.sa',
  'https://www.flickr.com',
  'https://www.ask.fm',
  'https://www.google.ru',
  'https://www.txxx.com',
  'https://www.billdesk.com',
  'https://www.ebay.de',
  'https://www.mi.com',
  'https://www.gamersky.com',
  'https://www.cctv.com',
  'https://www.google.com.hk',
  'https://www.redtube.com',
  'https://www.google.ae',
  'https://www.usps.com',
  'https://www.web.de',
  'https://www.comcast.net',
  'https://www.list.tmall.com',
  'https://www.nicovideo.jp',
  'https://www.douban.com',
  'https://www.sohu.com',
  'https://www.huanqiu.com',
  'https://www.about.com',
  'https://www.leboncoin.fr',
  'https://www.theladbible.com',
  'https://www.eastday.com',
  'https://www.onedio.com',
  'https://www.tokopedia.com',
  'https://www.ign.com',
  'https://www.aliexpress.com',
  'https://www.kissanime.to',
  'https://www.nytimes.com',
  'https://www.elpais.com',
  'https://www.amazon.it',
  'https://www.nownews.com',
  'https://www.steamcommunity.com',
  'https://www.thesaurus.com',
  'https://www.telegram.org',
  'https://www.dell.com',
  'https://www.telegraph.co.uk',
  'https://www.gearbest.com',
  'https://www.icloud.com',
  'https://www.douyu.com',
  'https://www.9gag.com',
  'https://www.amazon.cn',
  'https://www.groupon.com',
  'https://www.163.com',
  'https://www.soundcloud.com',
  'https://www.directrev.com',
  'https://www.google.dk',
  'https://www.iqiyi.com',
  'https://www.yesky.com',
  'https://www.ebay.in',
  'https://www.videomega.tv',
  'https://www.zillow.com',
  'https://www.soso.com',
  'https://www.beeg.com',
  'https://www.chinadaily.com.cn',
  'https://www.google.it',
  'https://www.google.co.th',
  'https://www.americanexpress.com',
  'https://www.naver.com',
  'https://www.themeforest.net',
  'https://www.bestbuy.com',
  'https://www.360.com',
  'https://www.mediafire.com',
  'https://www.indeed.com',
  'https://www.slickdeals.net',
  'https://www.xywy.com',
  'https://www.wetransfer.com',
  'https://www.intuit.com',
  'https://www.urdupoint.com',
  'https://www.doorblog.jp',
  'https://www.cnzz.com',
  'https://www.deviantart.com',
  'https://www.digikala.com',
  'https://www.google.com.tw',
  'https://www.detail.tmall.com',
  'https://www.behance.net',
  'https://www.aol.com',
  'https://www.citi.com',
  'https://www.bukalapak.com',
  'https://www.goal.com',
  'https://www.washingtonpost.com',
  'https://www.google.com.mx',
  'https://www.bloomberg.com',
  'https://www.whatsapp.com',
  'https://www.weebly.com',
  'https://www.icicibank.com',
  'https://www.ask.com',
  'https://www.adplxmd.com',
  'https://www.w3schools.com',
  'https://www.jd.com',
  'https://www.tudou.com',
  'https://www.blastingnews.com',
  'https://www.goo.ne.jp',
  'https://www.haosou.com',
  'https://www.amazon.fr',
  'https://www.globaloffers.link',
  'https://www.list-manage.com',
  'https://www.shutterstock.com',
  'https://www.salesforce.com',
  'https://www.media.tumblr.com',
  'https://www.blogspot.com',
  'https://www.reddituploads.com',
  'https://www.google.co.il',
  'https://www.mashable.com',
  'https://www.daum.net',
  'https://www.onet.pl',
  'https://www.4399.com',
  'https://www.prjcq.com',
  'https://www.xda-developers.com',
  'https://www.tumblr.com',
  'https://www.ok.ru',
  'https://www.goodreads.com',
  'https://www.tianya.cn',
  'https://www.verizonwireless.com',
  'https://www.mega.nz',
  'https://www.tmall.com',
  'https://www.secureserver.net',
  'https://www.wikihow.com',
  'https://www.google.com.ar',
  'https://www.google.pl',
  'https://www.pinimg.com',
  'https://www.adobe.com',
  'https://www.amazon.es',
  'https://www.microsoft.com',
  'https://www.taringa.net',
  'https://www.mama.cn',
  'https://www.zippyshare.com',
  'https://www.flipkart.com',
  'https://www.google.ro',
  'https://www.google.nl',
  'https://www.seznam.cz',
  'https://www.google.com.au',
  'https://www.ps4ux.com',
  'https://www.bongacams.com',
  'https://www.enet.com.cn',
  'https://www.bankofamerica.com',
  'https://www.nbcnews.com',
  'https://www.amazonaws.com',
  'https://www.livedoor.jp',
  'https://www.doublepimp.com',
  'https://www.webtretho.com',
  'https://www.hclips.com',
  'https://www.google.com.sg',
  'https://www.nordstrom.com',
  'https://www.lowes.com',
  'https://www.google.ca',
  'https://www.2ch.net',
  'https://www.gmw.cn',
  'https://www.google.hu',
  'https://www.google.ie',
  'https://www.ancestry.com',
  'https://www.bet365.com',
  'https://www.huffingtonpost.com',
  'https://www.wwwpromoter.com',
  'https://www.reuters.com',
  'https://www.merdeka.com',
  'https://www.walmart.com',
  'https://www.tube8.com',
  'https://www.exoclick.com',
  'https://www.vimeo.com',
  'https://www.uptodown.com',
  'https://www.wordpress.org',
  'https://www.marca.com',
  'https://www.kaskus.co.id',
  'https://www.thewhizmarketing.com',
  'https://www.vice.com',
  'https://www.rutracker.org',
  'https://www.tripadvisor.com',
  'https://www.popcash.net',
  'https://www.zol.com.cn',
  'https://www.stackoverflow.com',
  'https://www.putlocker.is',
  'https://www.theguardian.com',
  'https://www.zendesk.com',
  'https://www.livedoor.biz',
  'https://www.39.net',
  'https://www.box.com',
  'https://www.indiatimes.com',
  'https://www.kinopoisk.ru',
  'https://www.ikea.com',
  'https://www.airbnb.com',
  'https://www.google.com.eg',
  'https://www.google.gr',
  'https://www.1688.com',
  'https://www.le.com',
  'https://www.github.io',
  'https://www.trello.com',
  'https://www.kapanlagi.com',
  'https://www.go.com',
  'https://www.google.cz',
  'https://www.amazon.de',
  'https://www.sahibinden.com',
  'https://www.haber7.com',
  'https://www.force.com',
  'https://www.google.no',
  'https://www.dailymail.co.uk',
  'https://www.chaoshi.tmall.com',
  'https://www.google.de',
  'https://www.gmx.net',
  'https://www.wordpress.com',
  'https://www.amazon.ca',
  'https://www.rambler.ru',
  'https://www.stackexchange.com',
  'https://www.freepik.com',
  'https://www.wikia.com',
  'https://www.google.co.za',
  'https://www.china.com.cn',
  'https://www.sberbank.ru',
  'https://www.doubleclick.net',
  'https://www.allegro.pl',
  'https://www.independent.co.uk',
  'https://www.weather.com',
  'https://www.google.com.ph',
  'https://www.livejournal.com',
  'https://www.imdb.com',
  'https://www.hao123.com',
  'https://www.scribol.com',
  'https://www.nih.gov',
  'https://www.cnblogs.com',
  'https://www.ltn.com.tw',
  'https://www.kinogo.club',
  'https://www.naver.jp',
  'https://www.outbrain.com',
  'https://www.isanalyze.com',
  'https://www.dailymotion.com',
  'https://www.gamer.com.tw',
  'https://www.kohls.com',
  'https://www.cnnic.cn',
  'https://www.battle.net',
  'https://www.repubblica.it',
  'https://www.google.com.tr',
  'https://www.google.com.pe',
  'https://www.twitch.tv',
  'https://www.expedia.com',
  'https://www.taboola.com',
  'https://www.wellsfargo.com',
  'https://www.google.com.ua',
  'https://www.detik.com',
  'https://www.google.com.co',
  'https://www.dmm.co.jp',
  'https://www.bitauto.com',
  'https://www.addthis.com',
  'https://www.webmd.com',
  'https://www.ettoday.net',
  'https://www.albawabhnews.com',
  'https://www.homedepot.com',
  'https://www.google.com.ng',
  'https://www.ebay.co.uk',
  'https://www.blogspot.com.br',
  'https://www.popads.net',
  'https://www.google.fr',
  'https://www.hotstar.com',
  'https://www.google.be',
  'https://www.shopify.com',
  'https://www.adf.ly',
  'https://www.ebay-kleinanzeigen.de',
  'https://www.rakuten.co.jp',
  'https://www.diply.com',
  'https://www.paypal.com',
  'https://www.caijing.com.cn',
  'https://www.amazon.co.jp',
  'https://www.softonic.com',
  'https://www.usaa.com',
  'https://www.xfinity.com',
  'https://www.fedex.com',
  'https://www.twimg.com',
  'https://www.hatenablog.com',
  'https://www.cloudfront.net',
  'https://www.china.com',
  'https://www.speedtest.net',
  'https://www.mozilla.org',
  'https://www.sh.st',
  'https://www.quora.com',
  'https://www.spotify.com',
  'https://www.ifeng.com',
  'https://www.amazon.in',
  'https://www.mail.ru',
  'https://www.blkget.com',
  'https://www.dmm.com',
  'https://www.godaddy.com',
  'https://www.gizmodo.com',
  'https://www.torrentz.eu',
  'https://www.nbcolympics.com',
  'https://www.fc2.com',
  'https://www.ndtv.com',
  'https://www.mailchimp.com',
  'https://www.cntv.cn',
  'https://www.office.com',
  'https://www.hdfcbank.com',
  'https://www.target.com',
  'https://www.zoho.com',
  'https://www.51.la',
  'https://www.avito.ru',
  'https://www.abs-cbn.com',
  'https://www.adexc.net',
  'https://www.forbes.com',
  'https://www.youtube-mp3.org',
  'https://www.google.com.pk',
  'https://www.google.cl',
  'https://www.so.com',
  'https://www.hulu.com',
  'https://www.cnet.com',
  'https://www.chaturbate.com',
  'https://www.files.wordpress.com',
  'https://www.alibaba.com',
  'https://www.sourceforge.net',
  'https://www.alipay.com',
  'https://www.medium.com',
  'https://www.google.com.br',
  'https://www.rt.com',
  'https://www.google.es',
  'https://www.pinterest.com',
  'https://www.panda.tv',
  'https://www.t.co',
  'https://www.taleo.net',
  'https://www.t-online.de',
  'https://www.kickstarter.com',
  'https://www.friv.com',
  'https://www.suning.com',
  'https://www.google.fi',
  'https://www.github.com',
  'https://www.milliyet.com.tr',
  'https://www.coccoc.com',
  'https://www.capitalone.com',
  'https://www.badoo.com',
  'https://www.loading-delivery2.com',
  'https://www.xhamster.com',
  'https://www.snapdeal.com',
  'https://www.liputan6.com',
  'https://www.archive.org',
  'https://www.google.pt',
  'https://www.evernote.com',
  'https://www.fidelity.com',
  'https://www.sabah.com.tr',
  'https://www.att.com',
  'https://www.ameblo.jp',
  'https://www.oracle.com',
  'https://www.bild.de',
  'https://www.foxnews.com',
  'https://www.csdn.net',
  'https://www.bbc.com',
  'https://www.usatoday.com',
  'https://www.openload.co',
  'https://www.reimageplus.com',
  'https://www.lifehacker.com',
  'https://www.onlinesbi.com',
  'https://www.extratorrent.cc',
  'https://www.wsj.com',
  'https://www.tistory.com',
  'https://www.livedoor.com',
  'https://www.asos.com',
  'https://www.bilibili.com',
  'https://www.ups.com',
  'https://www.xnxx.com',
  'https://www.skype.com',
  'https://www.savefrom.net',
  'https://www.tribunnews.com',
  'https://www.51yes.com',
  'https://www.360.cn',
  'https://www.vk.com',
  'https://www.rio2016.com',
  'https://www.siteadvisor.com',
  'https://www.ozock.com',
  'https://www.daikynguyenvn.com',
  'https://www.cnn.com',
  'https://www.sogou.com',
  'https://www.orange.fr',
  'https://www.hp.com',
  'https://www.bp.blogspot.com',
  'https://www.avg.com',
  'https://www.varzesh3.com',
  'https://www.atlassian.net',
  'https://www.youku.com',
  'https://www.livejasmin.com',
  'https://www.wp.pl',
  'https://www.mercadolivre.com.br',
  'https://www.conservativetribune.com',
  'https://www.accuweather.com',
  'https://www.roblox.com',
  'https://www.google.co.kr',
  'https://www.xinhuanet.com',
  'https://www.google.co.id',
  'https://www.google.com.bd',
  'https://www.eksisozluk.com',
  'https://www.google.at',
  'https://www.pixiv.net',
  'https://www.sharepoint.com',
  'https://www.thepiratebay.org',
  'https://www.youth.cn',
  'https://www.wordreference.com',
  'https://www.scribd.com',
  'https://www.bbc.co.uk',
  'https://www.kakaku.com',
  'https://www.irctc.co.in',
  'https://www.olx.pl',
  'https://www.reddit.com',
  'https://www.google.com.vn',
  'https://www.google.se',
  'https://www.msn.com',
  'https://www.uploaded.net',
  'https://www.messenger.com',
  'https://www.blogspot.in',
  'https://www.naukri.com',
  'https://www.myway.com',
  'https://www.apple.com',
  'https://www.nhk.or.jp',
  'https://www.gfycat.com',
  'https://www.yelp.com',
  'https://www.ouo.io',
  'https://www.macys.com',
  'https://www.kompas.com',
  'https://www.pokevision.com',
  'https://www.espncricinfo.com',
  'https://www.pixnet.net',
  'https://www.imgur.com',
  'https://www.rarbg.to',
  'https://www.nyaa.se',
];

export const SEARCH_LANGUAGES = [
  'aa',
  'ab',
  'ae',
  'af',
  'ak',
  'am',
  'an',
  'ar',
  'as',
  'av',
  'ay',
  'az',
  'ba',
  'be',
  'bg',
  'bh',
  'bm',
  'bi',
  'bn',
  'bo',
  'br',
  'bs',
  'ca',
  'ce',
  'ch',
  'co',
  'cr',
  'cs',
  'cu',
  'cv',
  'cy',
  'da',
  'de',
  'dv',
  'dz',
  'ee',
  'el',
  'en',
  'eo',
  'es-149',
  'es-ES',
  'et',
  'eu',
  'fa',
  'ff',
  'fi',
  'fj',
  'fo',
  'fr',
  'fy',
  'ga',
  'gd',
  'gl',
  'gn',
  'gu',
  'gv',
  'ha',
  'he',
  'hi',
  'ho',
  'hr',
  'ht',
  'hu',
  'hy',
  'hz',
  'ia',
  'id',
  'ie',
  'ig',
  'ii',
  'ik',
  'io',
  'is',
  'it',
  'iu',
  'ja',
  'jv',
  'ka',
  'kg',
  'ki',
  'kj',
  'kk',
  'kl',
  'km',
  'kn',
  'ko',
  'ko-kr',
  'kr',
  'ks',
  'ku',
  'kv',
  'kw',
  'ky',
  'la',
  'lb',
  'lg',
  'li',
  'ln',
  'lo',
  'lt',
  'lu',
  'lv',
  'md-ru',
  'md-ro',
  'mg',
  'mh',
  'mi',
  'mk',
  'ml',
  'mn',
  'mr',
  'ms',
  'mt',
  'my',
  'na',
  'nb',
  'nd',
  'ne',
  'ng',
  'nl',
  'nl-be',
  'nn',
  'no',
  'nr',
  'nv',
  'ny',
  'oc',
  'oj',
  'om',
  'or',
  'os',
  'pa',
  'pi',
  'pl',
  'ps',
  'pt',
  'qu',
  'rm',
  'rn',
  'ro',
  'ru',
  'rw',
  'sa',
  'sc',
  'sd',
  'se',
  'sg',
  'si',
  'sk',
  'sl',
  'sm',
  'sn',
  'so',
  'sq',
  'sr',
  'ss',
  'st',
  'su',
  'sv',
  'sw',
  'ta',
  'te',
  'tg',
  'th',
  'ti',
  'tk',
  'tl',
  'tn',
  'to',
  'tr',
  'ts',
  'tt',
  'tw',
  'ty',
  'ug',
  'uk',
  'ur',
  'uz',
  've',
  'vi',
  'vo',
  'wa',
  'wo',
  'xh',
  'yi',
  'yo',
  'za',
  'zh',
  'zh-TW',
  'zu',
];

export const ACTIVE_BROWSER_PROFILE_IMPORT_LICENSES = [
  'MTExMTE4MDA4NDE4NzI0NzExMjUwMzMzMDcwMQ==',
  'bGVhcm4z',
  'QVRCMi1KTS0wMjE=',
  '504562991',
  '59166783',
  '807266505',
  '330005888204',
  '87249768503',
  '5716228182',
  '2607250211',
  '664779',
  '537805079',
  '65083655885',
  '8810286684',
  '37060975',
  '8429043168',
  '9615451814',
  '365513983371',
  '36510689467',
  '365334291360'
];

export const ACTIVE_BING_MODE_LICENSES = ['QVRCMi1KTS0wMjE=','bGVhcm4z','MTExMTE4MDA4NDE4NzI0NzExMjUwMzMzMDcwMQ=='];
